import { feedBannerPath } from '../../components/common/FeedBannerContent';

// Use the app's ordered home inventory on every screen size. appOnly is a legacy
// delivery flag, not a device-specific publication switch for this shared surface.
export function homeHeroBanners(data = {}) {
  return (data?.MOBILE || []).filter((item) => {
    if (item.appConfig?.enabled === false) return false;
    try {
      return (
        new URL(item.url || '/', 'https://postpop.kr').pathname.split('/').filter(Boolean)[0] !==
        'news'
      );
    } catch {
      return item.url?.split('?')[0].split('/').filter(Boolean)[0] !== 'news';
    }
  });
}
export function bannerCopy(banner, locale) {
  const config = banner.appConfig;
  if (!config)
    return {
      headline: (banner.title || '').replace(/\s*\((?:MO|PC)\)\s*$/i, ''),
      subtitle: locale === 'en' ? 'View details on Postpop' : '포스트팝에서 자세히 보기',
    };
  return {
    headline: (locale === 'en' && config.headlineEn) || config.headline || '',
    subtitle: (locale === 'en' && config.subtitleEn) || config.subtitle || '',
  };
}
export function bannerDestination(banner, origin) {
  const feed = feedBannerPath(banner);
  if (feed) return { path: feed };
  if (!banner.url?.trim()) return null;
  try {
    const url = new URL(banner.url, origin);
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return null;
    const own = [new URL(origin).host, 'postpop.kr', 'www.postpop.kr', 'sandbox.postpop.kr'];
    return own.includes(url.host)
      ? { path: `${url.pathname}${url.search}${url.hash}` }
      : { url: url.href };
  } catch {
    return null;
  }
}
